export const renderCapitalize = (value) => {
    return (
        <div className="capitalize">{value || '-'}</div>
    );
};